import Select from 'react-select'

export default class PowerSelect extends Select {}